// #380 / #126: duration-logging heartbeats must pause while the tab/window is
// hidden, so time spent on another tab is not counted as time viewing content.
// Extracted as a pure, testable predicate because the browser QA runner (CDP)
// cannot flip document.hidden headlessly, so this behavior is verified by unit
// test instead. Uses the standard Page Visibility API.
export function shouldSkipHeartbeat(doc) {
  const d = doc || (typeof document !== "undefined" ? document : undefined);
  if (!d) {
    return false;
  }
  // #385: read both signals. document.hidden is the primary flag; some
  // environments (and jsdom under test) only reflect the change on
  // visibilityState, so check it too. They mean the same thing per the Page
  // Visibility API (hidden === (visibilityState === "hidden")).
  return !!(d.hidden || d.visibilityState === "hidden");
}
